export const iconFontAwesomeEditingPaintbrush = (
	<i className="fa-solid fa-paintbrush"></i>
);
